import { Checkbox, CheckboxField, Label } from '@d-edge/overnight-hotelier-react'
import type { ReactNode } from 'react'

interface CheckProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  children: ReactNode
}

/** Kit checkbox wired to its label. */
export function Check({ checked, onChange, disabled, children }: CheckProps) {
  return (
    <CheckboxField disabled={disabled}>
      <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <Label>{children}</Label>
    </CheckboxField>
  )
}
